export function getParentOrigin() {
    var parentOrigin = new URLSearchParams(document.location.search).get('parentOrigin');
    if (!parentOrigin ||
        // It's possible for `window.origin` to return a string "null", so check
        // that to be safe: https://developer.mozilla.org/en-US/docs/Web/API/origin
        parentOrigin === 'null') {
        return undefined;
    }
    return parentOrigin;
}
var getPostMessageTargetOrigin = function () {
    var parentOrigin = getParentOrigin();
    // If the SDK (e.g. Portal v2.3.8 onwards) passes its window origin, that we
    // set it as the target origin here. But for older versions of Portal and
    // other SDKs, default to '*'.
    if (!parentOrigin) {
        return '*';
    }
    return parentOrigin;
};
export var postParentWindowMessage = function (message) {
    window.parent.postMessage(message, getPostMessageTargetOrigin());
};
